var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgComIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 18,
    viewBox: "0 0 28 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.1111 17V15.2222C21.1111 14.2792 20.7365 13.3748 20.0697 12.708C19.4029 12.0412 18.4986 11.6666 17.5556 11.6666H10.4445C9.50148 11.6666 8.59711 12.0412 7.93031 12.708C7.26352 13.3748 6.88892 14.2792 6.88892 15.2222V17",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14 8.11111C15.9637 8.11111 17.5556 6.51923 17.5556 4.55556C17.5556 2.59188 15.9637 1 14 1C12.0363 1 10.4445 2.59188 10.4445 4.55556C10.4445 6.51923 12.0363 8.11111 14 8.11111Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.4444 17V15.2222C26.4438 14.4344 26.1816 13.6691 25.6989 13.0465C25.2163 12.4239 24.5405 11.9792 23.7777 11.7822",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1.5555 17V15.2222C1.55609 14.4344 1.8183 13.6691 2.30095 13.0465C2.78361 12.4239 3.45939 11.9792 4.22217 11.7822",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2222 1.1156C20.987 1.31142 21.6649 1.75622 22.149 2.37988C22.633 3.00353 22.8958 3.77056 22.8958 4.56005C22.8958 5.34953 22.633 6.11656 22.149 6.74021C21.6649 7.36387 20.987 7.80867 20.2222 8.00449",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M7.77771 1.1156C7.0129 1.31142 6.33501 1.75622 5.85092 2.37988C5.36683 3.00353 5.10407 3.77056 5.10407 4.56005C5.10407 5.34953 5.36683 6.11656 5.85092 6.74021C6.33501 7.36387 7.0129 7.80867 7.77771 8.00449",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComIcon);
export default __webpack_public_path__ + "static/media/com-icon.8dcca38028b496da3053ca8fce2f1cef.svg";
export { ForwardRef as ReactComponent };